// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .square_wide {
  width: 100%;
  margin-left: 0;
  min-height: 2em;
  --border-radius: 0;
}
:host .square_wide .content-wrapper {
  display: flex;
  width: 100%;
  justify-content: flex-start; /* Moves content to the left */
  align-items: center;
}
:host .list-number {
  font-weight: bold;
  font-size: 1.2em;
}
:host .event-name {
  padding-left: 2px;
  font-size: 1.1em;
}
:host .event-text {
  padding-left: 2px;
  font-size: 0.8em;
}
:host .button-subtext {
  font-weight: lighter;
  text-transform: none;
  padding-left: 5px;
}
:host .button-inner {
  justify-content: flex-start;
}
:host img {
  max-width: 80px;
  max-height: 60px;
  width: auto;
  height: auto;
  display: block;
  justify-self: center;
}
:host .bold {
  font-weight: bold;
  text-transform: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
